<template>
  <div class="container">
    <div v-if="this.language == 'de'">
      <p>Sie haben spezielle gerätetechnische oder anwendungsspezifische Fragen? Während der Geschäftszeiten steht
        Ihnen unsere Hotline zur Verfügung.<br>
        <br>
        <div class="bigred">+49 (0)551/ 5 04 10-10</div>
        Unsere Mitarbeiter werden Sie gern u.a. bei der <br>
        <b>Fehlerursachenanalyse,<br>
          Fehlerbeseitigung </b>sowie bei<br>
        <b>Bedienproblemen </b>kompetent beraten.<br>
        <br>
        <br>
        Sie erreichen uns von:<br>
        <b>Montag bis Donnerstag von 8 - 17 Uhr und Freitag von 8 - 15 Uhr<br>
        </b>
      </p>
    </div>
    <div v-if="this.language == 'en'">
      <p>You have specific device-related or application-related questions? You may contact our hotline during the
        general business hours.<br>
        <br>
        <div class="bigred">+49 (0)551/ 5 04 10-10</div><br>
        <br>
        Our staff members stand ready to support and advice you for <br>
        <b>error cause analysis</b>, <br>
        <b>error correction </b>as well as <br>
        <b>operational problems</b>.<br>
        <br>
        <br>
        You may contact us: <br>
        <b>Monday to Thursday 8 a.m. to 5 p.m. and Friday 8 a.m. to 3 p.m.<br>
        </b>
      </p>
    </div>
  </div>
</template>
<script>
export default {
    name: 'servicehotline',
    data () {
      return {}
    }
};
</script>
<style>
	.container {
    color: black;
    margin: 1rem;
  }
  .bigred {
    font-size: 3rem;
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/servicehotline.vue